var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0486 1.61548H9.11523V3.22225H10.7473V4.31586H9.11523V5.38471H10.7306V6.46163H9.11523V7.53856H10.7306V8.61548H9.11523V9.6924H10.7306V10.7693H9.11523V12.3847H14.0486C14.2968 12.3847 14.4998 12.1742 14.4998 11.9162V2.08394C14.4998 1.82602 14.2968 1.61548 14.0486 1.61548ZM13.4229 10.7693H11.2691V9.6924H13.4229V10.7693ZM13.4229 8.61548H11.2691V7.53856H13.4229V8.61548ZM13.4229 6.46163H11.2691V5.38471H13.4229V6.46163ZM13.4229 4.30779H11.2691V3.23086H13.4229V4.30779Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.55562V12.4449L8.57692 14V0L0.5 1.55562ZM5.60892 9.73538L4.66931 7.959C4.63377 7.89277 4.59715 7.77108 4.55892 7.59392H4.54438C4.52662 7.67738 4.48462 7.80446 4.41838 7.97462L3.47554 9.73538H2.01146L3.74962 7.00862L2.15954 4.28131H3.65431L4.434 5.91662C4.49485 6.04585 4.54923 6.19931 4.59769 6.37646H4.61277C4.64346 6.26985 4.70054 6.11154 4.784 5.901L5.65092 4.28077H7.01969L5.38439 6.98492L7.06546 9.73485L5.60892 9.73538Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.de1326aee100608cb99810f8f1101073.svg";
export { ForwardRef as ReactComponent };